import { createListenerGA, trackEvents } from "./ga";

const trackComponent = ({

  // ONE SELECTOR
  selector,
  category = null,
  action = null,
  label = null,

  // TRACK IF SHOWN
  // When 'trackIfShown' is true use 'ifShownAction' to set a default action for this event
  trackIfShown = false,
  ifShownAction,

  // CHILDREN
  // Options for children if there are
  childrenSelector = ".js-track-event",
  childrenDefaultCategory = category,
  childrenDefaultAction = null // Default action for children when it has no 'data-track' attributes but it has 'childrenSelector'
}) => {
  const element = document.querySelector(selector);

  if (!element) return;

  // TRACK IF SHOWN
  // Track if a element is shown (works for parent element)
  if (trackIfShown && ifShownAction) trackEvents(category, ifShownAction, window.location.href);

  // TRACK A ELEMENT
  // You can track a element just using his selector and get the data from que data-attributes
  const {
    trackCategory = category,
    trackAction = action,
    trackLabel = label
  } = element.dataset;

  if (trackCategory && trackAction) {
    createListenerGA(element, "click", trackCategory, trackAction, trackLabel);
  }

  // TRACK CHILDREN
  // You can track childrend just using the 'childrenSelector' class name
  const childrenElements = element.querySelectorAll(childrenSelector);
  childrenElements.forEach((childElem) => {
    const {
      trackCategory = childrenDefaultCategory,
      trackAction = childrenDefaultAction,
      trackLabel
    } = childElem.dataset;

    if (trackCategory && trackAction) {
      createListenerGA(childElem, "click", trackCategory, trackAction, trackLabel);
    }
  });
};

export { trackComponent };
